import init from './thing'

const livestock =
{
    ...init
};

export default livestock ;
